import { render, staticRenderFns } from "./MorePhoto.vue?vue&type=template&id=4d8228f6&scoped=true"
import script from "./MorePhoto.vue?vue&type=script&lang=js"
export * from "./MorePhoto.vue?vue&type=script&lang=js"
import style0 from "./MorePhoto.vue?vue&type=style&index=0&id=4d8228f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8228f6",
  null
  
)

export default component.exports